import * as Sentry from '@sentry/nextjs'
import {isProductionHost} from './src/system/lib/isProductionHost'
import {CaptureConsole} from '@sentry/integrations'

window.addEventListener('load', () => {
  try {
    if (isProductionHost(window.location.href)) {
      Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        integrations: [
          new CaptureConsole({
            levels: ['error'],
          }),
        ],
        // Turn off tracking web performance as far as it's not supported in 9.1.2
        tracesSampleRate: 0,
        environment: 'production',
        // Turn off session tracking as far as it's not supported in 9.1.2
        autoSessionTracking: false,
      })
    }
  } catch (e) {
    window.console.log('Failed to initialize Sentry.')
  }
})
